import styled from 'styled-components';

export const UsdDonateWrapper = styled.div`
.orange-btn {
   width:100%;
   margin-top: 14px;
  
}
.input-group{
    height:48px;
    // margin-bottom: 14px;
    
    @media screen and (max-width: 991px){
        margin-bottom: 0px;
    }
.inputicon{
    background: #E1E1E1 0% 0% no-repeat padding-box;
    border-radius: 10px;
    padding: 0 19px;
    font-size: 18px;
    color: #333333;
    font-family: "Jost", sans-serif;
    font-weight:500;
}
.inputbox{
    background:  #F2F2F2 ;
    border: none;
    font-size: 18px;
    line-height:26px;
    font-family: "Jost", sans-serif;
    font-weight:400;
    &::-webkit-input-placeholder { /* Chrome/Opera/Safari */
        color: rgb(0 0 0 / 50%);
    }
    &::-moz-placeholder { /* Firefox 19+ */
        color: rgb(0 0 0 / 50%);
    }
    &:-ms-input-placeholder { /* IE 10+ */
        color: rgb(0 0 0 / 50%);
    }
    &:-moz-placeholder { /* Firefox 18- */
       color: rgb(0 0 0 / 50%);
    }
}
 .inputtext{
    background:  #F2F2F2 ;
    border-radius: 10px;
    padding: 0 19px;
    font-size: 18px;
    color: #333333;
    font-family: "Jost", sans-serif;
    font-weight:500;
    border: none;
 } 


}


`;



